const sbsText = (postType) => (`
    ... on ${postType}_Components_Components_SbsText {
        content
        cta {
            target
            title
            url
        }
        fieldGroupName
        icon {
            altText
            mimeType
            sourceUrl
        }
        settings {
            fieldGroupName
            reverseDirection
            spacing
            theme
            showComponentTitle
            componentTitle
        }
        title
    }
`
);

export default sbsText;
